import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSliderSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.168 17.102a.898.898 0 1 1 0 .002v-.002Zm-1.822-1a2.899 2.899 0 0 1 5.44 0H21v2h-3.213a2.899 2.899 0 0 1-5.442 0H3v-2h9.346Zm-3.412-3.207a.898.898 0 1 0 0-1.795.898.898 0 0 0 0 1.795Zm0-3.795c1.25 0 2.314.79 2.721 1.899H21v2h-9.346a2.899 2.899 0 0 1-5.44 0H3v-2h3.213A2.899 2.899 0 0 1 8.934 9.1Zm6.132.69c-1.25 0-2.314-.79-2.721-1.898H3v-2h9.346a2.899 2.899 0 0 1 5.44 0H21v2h-3.213a2.899 2.899 0 0 1-2.721 1.898Zm-.898-2.897v-.001a.898.898 0 1 1 0 .002v-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSliderSharp);
export default Memo;
